<template>
  <header class="header">
    <nav class="header__nav">
      <!-- <img src="../../../static/images/logo_hh.png" class="header__img" style="height:45px;" @click="goToIndex" alt="logo"> -->
      <img src="../../../static/images/logo_ryy.png" :class="this.$route.query.yanse == 1 ? 'header__img2' : 'header__img' " style="padding-left:15px;height:45px;" @click="goToIndex" alt="logo">
      <div class="header__info">
        <p class="header__tel">{{companyInfo.tel}}</p>
        <p class="header__open-time">9:00 - 17:30</p>
      </div>
      <div class="header__links">
        <router-link to="/" exact class="header__link">首页</router-link>
        <!--<router-link to="/products" exact-->
                     <!--:class="['header__link', $route.meta.name === 'productDetails' ? 'active' : '']" class="product_home">我要借款>>-->
        <!--</router-link>-->
        <!-- <div class="product_home" id="myProduct"
           @mouseover="over()">
          我要融资

          <div class="masking" v-show="isMasking" @mouseout="out()"  @mouseover="over()">
            <ul class="masking_list">
              <li v-for="(item,index) in listData" :key=index>

                <router-link :to="{ path:'/products/', query: {customerType:customerType,categoryCode:item.categoryCode} }">{{item.categoryName}}</router-link>
              </li>
            </ul>
          </div>
        </div>  -->
         <router-link :to="{ path:'/products/', query: {customerType:1,categoryCode:1003} }"
         :class="['header__link',  $route.meta.name === 'myLoan_bl'&&$route.path=='/products/' ? 'active' : '']">
         我要申请</router-link>
        <router-link to="/personalCenter/myLoan_bl/loanLists_bl?frontApplyState=0&pageCount=1&applyState=all" exact
                     :class="['header__link',  $route.meta.name === 'myLoan_bl' ? 'active' : '']">我的保理
        </router-link>
        <router-link to="/aboutUs" exact class="header__link">关于我们</router-link>
        
        <!--<router-link to="#" exact class="header__link">帮助中心</router-link>-->
      </div>
     
      <template v-if="isLogin">
        <div class="header__user">
          
          <router-link to="/personalCenter/myLoan_bl/loanLists_bl" class="header__user--tel">{{userInfo.crmCustomerLoginName |
            encryptCellphone}}
          </router-link>
          <router-link to="/personalCenter/message" :class=" this.$store.state[1].msgNum > 0 ? 'headerBox' : ''" class="header__link">
          <i class="el-icon-message"><span class="mesnum">({{this.$store.state[1].msgNum}})</span></i>
          </router-link>
          <a class="header__logout" @click.prevent="logout">退出登录</a>
        </div>
      </template>
      <template v-else>
        <div class="header__user">
          <router-link to="/login" exact class="header__login">登录</router-link>
          <router-link to="/register" exact class="header__register">注册</router-link>
        </div>
      </template>
    </nav>

  </header>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import * as types from '../../vuex/types';
  import api from '../../api/home';
  import messageApi from '../../api/message';

  export default {
    data () {
      return {
        subNavData: [],
        isMasking: false,
        customerType: 1,
        listData: '',
        result: ''
    //       listData:[
    //           {productName: "信贷业务", yearRate: "8", title: "信贷"},
    //           {productName: "保理业务", yearRate: "21", title: "保理"},
    //           {productName: "票据业务", yearRate: "18", title: "票据"},
    //           {productName: "预付款融资", yearRate: "12", title: "预付"},
    //           {productName: "订单融资", yearRate: "45", title: "订单"},
    //           {productName: "融资租赁", yearRate: "5", title: "融资"},
    //
    // ]
      };
    },
    computed: {
      ...mapGetters({
        companyInfo: types.GET_COMPANY_INFO,
        isLogin: types.IS_LOGIN,
        userInfo: types.GET_USER
      })
    },
    watch: {
      $route (to, from) {
        this.isMasking = false;
      }
    },
    created () {
      this.getHomeList();
      this.getunread();
    },
    methods: {
      ...mapActions({
        userLogout: types.USER_LOGOUT,
        getEnableCreditQuotaSwitch: types.GET_ENABLE_CREDIT_QUOTA_SWITCH
      }),
      logout () {
        this.userLogout({
          router: this.$router
        });
        this.$store.state[1].msgNum == 0;
      },
      goToIndex () {
        this.$router.push({path: '/'});
      },
      // 头部我要借款鼠标悬停事件
      over () {
        this.isMasking = true;
      },
      out () {
        this.isMasking = false;
      },
      getunread () {
        messageApi.unRead({
          tokenId: localStorage.getItem('dl_tokenId_bl')
        }).then((res) => {
          if (res.code === 0) {
            this.$store.commit('changeState', res.result);
            this.result = res.result;
          } else {
          }
        }).catch((err) => {
          console.log('err', err);
        });
      },
      getHomeList () {
        const _this = this;

        api.getSubNav().then((res) => {
          if (res.rspcode == 1) {
            const data = res.data;
            _this.listData = data;
          } else {

          }
        }).catch((err) => {

        });
      }
    },
    mounted () {
      this.result = this.$store.state[1].msgNum;    // 检测是否启用额度
      this.$route.query.yanse;
      this.getEnableCreditQuotaSwitch();
        // this.$router.push({
        //     path: '/personalCenter/myLoan/loanLists',
        //     query: {frontApplyState: 0, pageCount: 1}
        // })
    }
  };
</script>
<style lang="scss">
  @mixin linkActive {
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
    cursor: pointer;
    &.active {
      color: #EB662B;
    }
  }

  .header {
    position: fixed;
    top: 0;
    z-index: 1000;
    width: 100%;
    background: #FFFFFF;
    .cur{
      color:$waterBlue;
    }
  }

.product_home{
  display: inline-block;
  position: relative;
  margin-left: 45px;
  color: #fff;
  font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
  cursor: pointer;
  &:hover{
   color:#00c0ff;
  }
}
  .header__img {
    cursor: pointer;
    @include floatLeft;
  }
 .header__img2 {
   display: none;
    cursor: pointer;
    @include floatLeft;
  }

  .header__nav {
    @include clear;
    padding-left: calc(100vw - 100%);
    margin: 0 auto;
    width: $containerWidth;
    height: 50px;
  }

  .header__info {
    @include floatLeft;
    margin-top: 10px;
    margin-left: 15px;
    padding-right: 8px;
    height: 30px;
    border-right: 1px solid #fff;
    text-align: right;
  }

  .header__tel {
    font-family: MyriadPro-Regular, Arial;
    font-size: 14px;
    line-height: 15px;
    color: #666666;
  }

  .header__open-time {
    font-family: MyriadPro-Regular, Arial;
    font-size: 12px;
    line-height: 15px;
    color: #34495E;
  }

  .header__links {
    @include floatLeft;
    // margin-left: 180px;
    line-height: 50px;
    // min-width: 490px;
    text-align: left;
    padding-left:65px;
  }

  .header__link {
    margin-left: 16px;
    color: #666666;
    @include linkActive;

    &:first-child {
      margin-left: 0;
    }
  }

  .header__user {
    @include floatRight;
    line-height: 50px;
    @include linkActive;
  }

  .header__user--tel {
    color: #EB662B;
  }

  .header__login {
    color: #666666;
    @include linkActive;
  }

  .header__register, .header__logout {
    margin-left: 10px;
    color: #666666;
    @include linkActive;
  }

  .masking {
    width: 200px;
    padding-top: 40px;
    position: absolute;
    /*background: red;*/
    top: 20px;
    left: -70px;
    /*left: 570px;*/
    .masking_list {
      width: 200px;
      height: 180px;
      background: #fff;
      font-size: 16px;
      border-radius: 8px;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        top: -20px;
        left: 90px;
        display:inline-block;
        width: 0;
        height: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 20px solid #fff;
      }
      li {
        line-height: 46px;
        text-align: center;

        border-bottom: 1px solid #D7D7D7;
        a {
          color: #666;
          &:hover{
            color:#00c0ff;
          }
        }
        &:last-of-type {
          border-bottom: none;
        }
      }
    }
  }
  @keyframes fade {
    from {
        opacity: 1.0;
    }
    50% {
        opacity: 0.4;
        color: #EB662B;
    }
    to {
        opacity: 1.0;
    }
}

@-webkit-keyframes fade {
    from {
        opacity: 1.0;
    }
    50% {
        opacity: 0.4;
        color: #EB662B;
    }
    to {
        opacity: 1.0;
    }
}
.headerBox {
    font-size: 15px;
    animation: fade 600ms infinite;
    -webkit-animation: fade 600ms infinite;
}
.mesnum{
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// Header.vue?51b2af63